/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State

==========================================================================================*/


export default {

  token: localStorage.getItem('access_token') || null,
  useractiveInfo:null

}
